export default __webpack_public_path__ + "static/media/Exhausting Traps.9c42b971.jpg";